import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ConnectorGroup } from 'models/ConnectorGroup';

type EditProps = {
  connectorGroup: ConnectorGroup;
  onSave: (connectorGroup: ConnectorGroup) => void;
  onCancel: () => void;
  handleUpdate: (id: number, updatedConnectorGroup: ConnectorGroup) => Promise<void>;
};

const ConnectorGroupEditForm: React.FC<EditProps> = ({ connectorGroup, onSave, onCancel, handleUpdate }) => {
  const [formData, setFormData] = useState<ConnectorGroup>({ ...connectorGroup });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      await handleUpdate(formData.id, formData);
      onSave(formData);
    } catch (error) {
      console.error('Error updating connectorGroup:', error);
    }
  };

  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void handleSubmit();
  };

  return (
    <Modal show onHide={onCancel}>
      <Form onSubmit={handleFormSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formDisplayName">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="display_name"
              value={formData.display_name}
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ConnectorGroupEditForm;
